import { create } from 'zustand'

interface IOrderInfoStore {
  refNo: string
  saveCurrentRefNo: (refNo: string) => void
  clearRecentRefNo: () => void
}

export const useOrderInfoStore = create<IOrderInfoStore>(set => ({
  refNo: '',
  saveCurrentRefNo: (refNo: string) => set({ refNo }),
  clearRecentRefNo: () => set({ refNo: '' }),
}))
